
export type MissingInfoSeverity = "high" | "medium" | "low";

export interface MissingInfoLabel {
    title: string;
    description: string;
    severity: MissingInfoSeverity;
    cta: string;
}

export const MISSING_INFO_LABELS: Record<string, MissingInfoLabel> = {
    MISSING_NET_VALUE: {
        title: "Total value of the estate",
        description: "We need the net value (total assets minus debts) to check for inheritance tax.",
        severity: "high",
        cta: "Add assets or debts"
    },
    MISSING_NET_FOR_TAPER: {
        title: "Exact net value for tapering",
        description: "The home allowance is reduced for estates over £2m. We need the net value to confirm if this applies.",
        severity: "high",
        cta: "Add assets or debts"
    },

    MISSING_MAIN_RESIDENCE_SELECTION: {
        title: "Identify the main residence",
        description: "To apply the home allowance (RNRB), please select the main home in the Assets list.",
        severity: "high",
        cta: "Go to Assets"
    },
    MULTIPLE_MAIN_RESIDENCES: {
        title: "Too many main residences",
        description: "You have marked more than one property as the main residence. Please select only one.",
        severity: "high",
        cta: "Fix properties"
    },
    MISSING_DECEASED_SHARE_PERCENT: {
        title: "Deceased's share missing",
        description: "We need the percentage of the main home owned by the deceased.",
        severity: "high",
        cta: "Edit home share"
    },
    MISSING_MAIN_RESIDENCE_VALUE: {
        title: "Main home value missing",
        description: "Please enter the estimated value of the main residence.",
        severity: "high",
        cta: "Edit value"
    },
    MISSING_HOME_INHERITANCE_DESTINATION: {
        title: "Inheritance details missing",
        description: "Who inherits the deceased's share of the main home? This affects the tax allowance.",
        severity: "high",
        cta: "Edit inheritance"
    },

    MISSING_UNUSED_NRB_PERCENT: {
        title: "Transferable allowance (optional)",
        description: "If there was a late spouse or civil partner, you can often claim their unused tax-free allowance.",
        severity: "low",
        cta: "Set percentage"
    },
    MISSING_UNUSED_RNRB_PERCENT: {
        title: "Transferable home allowance (optional)",
        description: "You may also be able to claim a late spouse's unused home allowance.",
        severity: "low",
        cta: "Set percentage"
    },
    MISSING_ASSET_INFO: {
        title: "Asset ownership details",
        description: "We need to know if any property or bank accounts were owned in the deceased's name only.",
        severity: "high",
        cta: "Edit assets"
    }
};
